import ImageLoader from '../ImageLoader';
import PromoCard from './Card';
import useNavigation from '../../hook/useNavigation';
import { LoaderIcon } from '../../utils/svg';
import { buildSafeLink, isEmptyData, encodeValue } from '../../utils/helper';

const Promo = (props) => {
	const { banner, isLoading } = props;
  
	const navigate = useNavigation();

	const handleClick = () => {
		navigate.push(buildSafeLink(banner?.banner_link)+'&banner_id=' + encodeValue(banner?.banner_id));
	};

	return (
		<div className={`w-full h-[250px] relative mb-4 ${(isEmptyData(banner?.banner_image) && isEmptyData(banner?.outlets)) && 'hidden' }`}>
			<ImageLoader src={banner?.banner_image} className='absolute w-full h-full max-h-64 object-fill' />
			<div className='absolute z-[0] w-full h-full flex justify-between'>
				<div className='min-w-[42%] p-4 flex justify-center items-end'>
					<div onClick={handleClick} className='bg-yellow-500 text-center rounded-full px-2 py-2 w-full max-w-24 text-xs capitalize font-bold text-gray-800 cursor-pointer'>
						see all
					</div>
				</div>
				{isLoading ? (
					<div className='w-full flex justify-center items-center'>
						<LoaderIcon />
					</div>
				) : (
					<div className='w-[58%] overflow-x-auto overflow-y-hidden p-4 scrollbar-hide'>
						<div className='flex w-max h-full gap-4'>
							{banner?.outlets?.slice(0, 5)?.map((item, index) => (
								<div key={index} className='shrink-0'>
									<PromoCard {...{ item }} />
								</div>
							))}
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default Promo;
